import { CategoricalVariableStatsDto, ScalarVariableStatsDto } from "app/ApiClient";
import { LoadingState } from "types";

export interface VariableStatsState {
  scalarStats: Nullable<ScalarVariableStatsDto>;
  categoricalStats: Nullable<CategoricalVariableStatsDto>;
  loading: LoadingState;
}
export const initialVariableStatsState: VariableStatsState = {
  loading: LoadingState.idle,
  scalarStats: null,
  categoricalStats: null,
};
